import { useMemo, useState } from 'react'

import { noop } from 'lodash-es'

import { LYRA_ALL_CUSTOMER_HIGH_ALERT_TEAM_PHONE } from '../../common/constants/constants'

export const useMakeOnsiteModalProps = ({
  onContinue = noop,
  customerDisplayName,
  isInternationalUser = false,
  outOfCountryPhoneNumbers,
  customerTollFreePhoneNumbers,
}: {
  onContinue?: () => void
  customerDisplayName?: string
  isInternationalUser?: boolean
  outOfCountryPhoneNumbers?: null | string[]
  customerTollFreePhoneNumbers?: null | string[]
}) => {
  const [isOnsiteModalOpen, setIsOnsiteModalOpen] = useState(false)

  let customerPhoneNumber = LYRA_ALL_CUSTOMER_HIGH_ALERT_TEAM_PHONE
  if (isInternationalUser) {
    if (customerTollFreePhoneNumbers && customerTollFreePhoneNumbers?.length > 0) {
      customerPhoneNumber = customerTollFreePhoneNumbers[0]
    } else if (outOfCountryPhoneNumbers && outOfCountryPhoneNumbers?.length > 0) {
      customerPhoneNumber = outOfCountryPhoneNumbers[0]
    }
  }

  return useMemo(() => {
    return {
      isVisible: isOnsiteModalOpen,
      customerDisplayName,
      onContinue,
      setIsModalOpen: (isOpen: boolean) => {
        setIsOnsiteModalOpen(isOpen)
      },
      onExit: () => setIsOnsiteModalOpen(false),
      customerPhoneNumber,
      sessionLengthInMinutes: 50,
      isInternationalUser,
    }
  }, [customerDisplayName, customerPhoneNumber, isInternationalUser, isOnsiteModalOpen, onContinue])
}
